import { api } from "@/lib/api"

export interface PortalContentCounts {
	articles: number
	publishedArticles: number
	groups: number
	changelogs: number
	publishedChangelogs: number
}

const EMPTY: PortalContentCounts = {
	articles: 0,
	publishedArticles: 0,
	groups: 0,
	changelogs: 0,
	publishedChangelogs: 0,
}

/**
 * Counts for every portal in one server round trip. Counting through Zero would
 * sync the whole article and changelog table to the client just to call .length.
 */
export function usePortalContentCounts() {
	const { data } = api.workspace.portalContentCounts.useQuery(undefined, {
		staleTime: 30_000,
	})

	// "main" is the portal that owns every item with no portal of its own.
	return (portalInstanceId: string | null): PortalContentCounts =>
		data?.[portalInstanceId ?? "main"] ?? EMPTY
}
